module.exports = __webpack_public_path__ + "static/media/kvk-fp.892bd8f3.png";